module.exports = __webpack_public_path__ + "img/left2.d57a0025.svg";